// extracted by mini-css-extract-plugin
export var pillWrapper = "_jd-0";
export var showOverflow = "_jd-1";